import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, ArrowLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-ink-850 border border-white/15 px-4 py-3 text-white placeholder:text-zinc-600 focus:border-brand focus:outline-none transition-colors duration-200";

  return (
    <div className="min-h-screen bg-ink-950 flex items-center justify-center px-6" data-testid="admin-login-page">
      <Link to="/" className="absolute top-8 left-8 inline-flex items-center gap-2 text-zinc-500 hover:text-white transition-colors" data-testid="login-back-link">
        <ArrowLeft size={16} /> Back to site
      </Link>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md"
      >
        <p className="font-jmono text-xs uppercase tracking-[0.3em] text-brand mb-3">[ Admin ]</p>
        <h1 className="font-syne text-4xl font-extrabold tracking-tighter mb-8">
          GoBuild<span className="text-brand">Web</span> Console
        </h1>
        <form onSubmit={submit} className="flex flex-col gap-4" data-testid="admin-login-form">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={inputCls}
            data-testid="login-email-input"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={inputCls}
            data-testid="login-password-input"
          />
          {error && (
            <p className="text-red-400 text-sm" data-testid="login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            className="inline-flex items-center justify-center gap-2 bg-brand hover:bg-brand-hover disabled:opacity-60 text-white px-6 py-3 font-medium transition-colors duration-200"
            data-testid="login-submit-button"
          >
            {loading && <Loader2 size={18} className="animate-spin" />}
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
